import { createTrackStandaloneEventHook } from './useTrackStandaloneEvent';
export const useTrackSearchResultViewed = createTrackStandaloneEventHook('Search Result Viewed');